import { useState } from 'react';
import { useCategories, useCreateCategory, useUpdateCategory, useDeleteCategory } from '@/hooks/useApi';

export default function CategoryModal({ onClose }) {
  const { data: categories = [], isLoading } = useCategories();
  const createCat = useCreateCategory();
  const updateCat = useUpdateCategory();
  const deleteCat = useDeleteCategory();

  const [form, setForm] = useState({ name: '', type: 'expense' });
  const [editId, setEditId] = useState(null);
  const [err, setErr] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    if (!form.name.trim()) return setErr('Nama kategori wajib diisi.');
    try {
      if (editId) {
        await updateCat.mutateAsync({ id: editId, ...form });
      } else {
        await createCat.mutateAsync(form);
      }
      setForm({ name: '', type: 'expense' });
      setEditId(null);
    } catch (e) {
      setErr(e.response?.data?.error || 'Gagal menyimpan kategori.');
    }
  };

  const handleDelete = async (id) => {
    setErr('');
    try {
      await deleteCat.mutateAsync(id);
    } catch (e) {
      setErr(e.response?.data?.error || 'Gagal hapus — kategori mungkin masih dipakai transaksi.');
    }
  };

  const startEdit = (cat) => {
    setEditId(cat.id);
    setForm({ name: cat.name, type: cat.type });
    setErr('');
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 100,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px',
      boxSizing: 'border-box'
    }}>
      <div style={{
        background: 'white', border: '2px solid var(--line)', boxShadow: '4px 4px 0 var(--line)',
        width: '100%', maxWidth: '500px', padding: 'clamp(16px, 4vw, 24px)', maxHeight: '90vh',
        overflowY: 'auto', overflowX: 'hidden', boxSizing: 'border-box'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '18px' }}>
          <div>
            <span className="panel-kicker">MANAGE</span>
            <h3 style={{ margin: '4px 0 0', font: "700 20px 'Space Grotesk'", letterSpacing: '-0.5px' }}>Kelola Kategori</h3>
          </div>
          <button onClick={onClose} aria-label="Tutup" style={{ border: 'none', background: 'none', fontSize: '24px', cursor: 'pointer', lineHeight: 1, padding: '4px' }}>×</button>
        </div>

        {err && (
          <div style={{ background: '#fff0ed', border: '1px solid var(--red)', padding: '10px 14px', marginBottom: '16px', color: 'var(--red)', fontSize: '12px', fontWeight: 700 }}>
            {err}
          </div>
        )}

        {/* Form add/edit */}
        <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '8px', marginBottom: '24px', flexWrap: 'wrap' }}>
          <input
            value={form.name}
            onChange={(e) => setForm(p => ({ ...p, name: e.target.value }))}
            placeholder="Nama kategori"
            style={{ flex: '1 1 160px', border: '2px solid var(--line)', padding: '8px 12px', font: '13px inherit', outline: 'none' }}
          />
          <select
            value={form.type}
            onChange={(e) => setForm(p => ({ ...p, type: e.target.value }))}
            style={{ border: '2px solid var(--line)', padding: '8px 10px', font: '13px inherit', background: 'white', outline: 'none' }}
          >
            <option value="expense">Pengeluaran</option>
            <option value="income">Pemasukan</option>
            <option value="saving">Tabungan</option>
          </select>
          <button type="submit" className="primary-button" style={{ whiteSpace: 'nowrap' }}>
            {editId ? '✏️ UPDATE' : '＋ TAMBAH'}
          </button>
          {editId && (
            <button type="button" onClick={() => { setEditId(null); setForm({ name: '', type: 'expense' }); }}
              style={{ border: '2px solid var(--line)', padding: '8px 12px', background: 'transparent', cursor: 'pointer', font: "8px 'Press Start 2P'" }}>
              BATAL
            </button>
          )}
        </form>

        {/* Category list */}
        {isLoading ? (
          <p style={{ color: 'var(--muted)', fontSize: '13px' }}>Memuat kategori...</p>
        ) : categories.length === 0 ? (
          <p style={{ color: 'var(--muted)', fontSize: '13px' }}>Belum ada kategori. Tambahkan yang pertama!</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {categories.map(cat => (
              <div key={cat.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px', border: '1px solid #e8e5e0' }}>
                <span style={{ flex: 1, fontSize: '13px', fontWeight: 700 }}>{cat.name}</span>
                <span style={{
                  font: "7px 'Press Start 2P'", padding: '4px 8px',
                  background: cat.type === 'income' ? '#e8f5e9' : cat.type === 'saving' ? '#e3f2fd' : '#fff0ed',
                  color: cat.type === 'income' ? '#2e7d32' : cat.type === 'saving' ? '#1565c0' : 'var(--red)',
                  border: '1px solid',
                  borderColor: cat.type === 'income' ? '#a5d6a7' : cat.type === 'saving' ? '#90caf9' : '#ffc5ba'
                }}>
                  {cat.type === 'income' ? 'PEMASUKAN' : cat.type === 'saving' ? 'TABUNGAN' : 'PENGELUARAN'}
                </span>
                <button onClick={() => startEdit(cat)}
                  style={{ border: '1px solid var(--line)', padding: '5px 9px', background: 'transparent', cursor: 'pointer', fontSize: '12px' }}>
                  ✏️
                </button>
                <button onClick={() => handleDelete(cat.id)}
                  style={{ border: '1px solid #ffc5ba', padding: '5px 9px', background: '#fff0ed', color: 'var(--red)', cursor: 'pointer', fontSize: '12px' }}>
                  🗑️
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
